<div class="space-y-4">
  <webmodule-order-panel>
      <ng-container heading>
        <h3 class="mb-0">{{ 'block.details.detail.heading' | translate }}</h3>
      </ng-container>
      <ng-container content>

        @if (customer(); as customer) {
          <dl class="data-list">
            @if (customer.companyName) {
              <div class="container">
                <dt class="">{{ 'block.details.input.company-name.label' | translate }}</dt>
                <dd class="">{{ customer.companyName }}</dd>
              </div>
              <div class="container">
                <dt class="">{{ 'block.details.input.coc-number.label' | translate }}</dt>
                <dd class="">{{ customer.kvkNumber }}</dd>
              </div>
            }
            <div class="container">
              <dt class="">{{ 'block.customer.label.full-name' | translate }}</dt>
              <dd class="">{{ customer.firstName }} {{ customer.lastName }}</dd>
            </div>

            <div class="container">
              <dt class="">{{ 'block.details.input.email.label' | translate }}</dt>
              <dd class="">{{ customer.email }}</dd>
            </div>
            <div class="container">
              <dt class="">{{ 'block.details.input.phone-number.label' | translate }}</dt>
              <dd class="">{{ customer.phoneNumber }}</dd>
            </div>
          </dl>
        }
      </ng-container>
  </webmodule-order-panel>

  <webmodule-order-panel>
      <ng-container heading>
        <h3 class="mb-0">{{ 'block.details.delivery.heading' | translate }}</h3>
      </ng-container>
      <ng-container content>

        <dl class="data-list">
          @if (address(); as address) {
            <div class="container">
              <dt class="">{{ 'block.customer.label.delivery-address' | translate }}</dt>
              <dd class="">
                 <p>{{ address.street }} {{ address.houseNumber }}
                   @if (address.houseNumberAddition; as addition) {
                     {{ addition }}
                   }
                </p>
                <p class="mb-0">{{ address.postcode }} {{ address.city }}</p>
              </dd>
            </div>
          }

          @if (customer(); as customer) {
            <div class="container">
              <dt class="">{{ 'block.details.input.iban-number.label' | translate }}</dt>
              <dd class="">{{ customer.iban }}</dd>
            </div>
          }

        </dl>
      </ng-container>
  </webmodule-order-panel>


</div>
